<div class="static-container">
  <h4>
    Cookie Policy
  </h4>

  <div class="mb-5">
    <p class="gray-text">
      This Cookie Policy explains how DML  Test Mode(“we”, “us”, or “our”) uses cookies and similar technologies when you visit
      our website <a routerLink="/">www.djmixinglab.com</a>. By continuing to use our website,
      you consent to the use of cookies in accordance with this policy.
    </p>
  </div>

  <div class="mb-5">
    <p class="heading-color">
      <strong>What Are Cookies?</strong>
    </p>
    <p class="gray-text">
      Cookies are small data files that are placed on your computer or mobile device when you visit a website. Cookies
      are widely used by website owners to make their websites work, or to work more efficiently, as well as to
      provide reporting information.
    </p>
    <p class="gray-text">
      Cookies set by the website owner (in this case, DML) are called “first-party cookies”. Cookies set by parties
      other than the website owner are called “third-party cookies”. Third-party cookies enable third-party features
      or functionality to be provided on or through the website (e.g., advertising, interactive content, and analytics).
    </p>
  </div>

  <div class="mb-5">
    <p class="heading-color"><strong>Why We Use Cookies</strong></p>
    <p class="gray-text">
      We use cookies to:
    </p>
    <ul class="gray-text ps-5">
      <li>Ensure the website functions properly</li>
      <li>Remember your preferences and settings</li>
      <li>Analyze site traffic and usage</li>
      <li>Deliver targeted advertisements</li>
      <li>Enhance your browsing experience</li>
    </ul>
  </div>

  <div class="mb-5">
    <p class="heading-color"><strong>Types of Cookies We Use</strong></p>

    <p class="heading-color mt-3"><strong>Strictly Necessary Cookies</strong></p>
    <p class="gray-text">
      These cookies are essential for enabling you to move around the website and use its features, such as accessing
      secure areas. Without these cookies, services you have asked for cannot be provided.
    </p>

    <p class="heading-color mt-3"><strong>Performance Cookies</strong></p>
    <p class="gray-text">
      These cookies collect information about how visitors use our website, such as which pages are visited most
      often. This data is used to improve how our website works.
    </p>

    <p class="heading-color mt-3"><strong>Functionality Cookies</strong></p>
    <p class="gray-text">
      These cookies allow our site to remember choices you make (such as your language or the region you are in) and
      provide enhanced, more personal features.
    </p>

    <p class="heading-color mt-3"><strong>Targeting/Advertising Cookies</strong></p>
    <p class="gray-text">
      These cookies are used to deliver advertisements more relevant to you and your interests. They also limit the
      number of times you see an advertisement and help measure the effectiveness of advertising campaigns.
    </p>
  </div>

  <div class="mb-5">
    <p class="heading-color"><strong>Managing Cookies</strong></p>
    <p class="gray-text">
      You can control and manage cookies in various ways. Please note that removing or blocking cookies can impact
      your user experience and parts of our website may no longer be fully accessible.
    </p>
    <ul class="gray-text ps-5">
      <li>You can set your browser to refuse all or some cookies, or to alert you when websites set or access cookies.</li>
      <li>You can also delete cookies already stored on your device through your browser settings.</li>
    </ul>
  </div>

  <div class="mb-5">
    <p class="heading-color"><strong>Update to This Policy</strong></p>
    <p class="gray-text">
      We may update this Cookie Policy from time to time to reflect changes in law, technology, or our business practices. When we make changes, we’ll update the “Effective Date” at the top of the page. Please check this page periodically for updates.
    </p>
  </div>

  <div class="mb-5">
    <p class="heading-color"><strong>Contact Us</strong></p>
    <p class="gray-text">
      If you have any questions about our use of cookies or this Cookie Policy, please contact us at:
      <a href="mailto:support@djmixinglab.com">support&#64;djmixinglab.com</a>
    </p>
  </div></div>
